<template>
  <el-button type="info" class="btn btn-info admin-print" @click="print">
    Распечатать
  </el-button>
</template>
<script>
import applicationApi from '@/api/application'
import {mapState} from 'vuex'
import {printFile} from '@/helpers/applicants'

export default {
  computed: {
    ...mapState({
      category: state => state.admin.category,
      page: state => state.admin.page,
      pageSize: state => state.admin.pageSize,
      sorting: state => state.admin.sorting,
      searchString: state => state.admin.searchString,
      filter: state => state.admin.filter
    })
  },
  methods: {
    print: function () {
      let applicationsIds = this.$store.state.admin.printIds
      if(applicationsIds.length > 0){
        const requestParams = {}

        this.filter.map(filter => {
          if(filter.by === 'period') {
            requestParams['date_insert__gte'] = filter.value[0]
            requestParams['date_insert__lte'] = filter.value[1]
          } else {
            requestParams[filter.by] = filter.value
          }
        })

        if(this.sorting.by && this.sorting.direction){
          const orderingName = this.sorting.by.includes('.')
            ? this.sorting.by.replace('.', '__')
            : this.sorting.by
          requestParams['ordering'] = `${this.sorting.direction === 'ascending' ? '' : '-'}${orderingName}`
        }

        if(this.searchString){
          requestParams['full_name'] = this.searchString
        } else {
          delete requestParams['full_name']
        }

        applicationApi.getReportAllXlsxl(requestParams).then((response) => {
          printFile(response.data, 'Список заявлений.xlsx')
        })
      }
    },
  },
}
</script>
